// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"32aaa6a2","787":"a542a446","846":"c55f6dcb"}[chunkId] + ".chunk.js";
};